module.exports = __webpack_public_path__ + "static/beer_Beer_Animations_1-a748b13e4ec4ce756d96959c5c335086.png";